const MOODS = [
  { value: 1, label: 'خیلی بد', color: '#dc2626', bg: '#fef2f2', ring: '#fecaca' },
  { value: 2, label: 'بد', color: '#ea580c', bg: '#fff7ed', ring: '#fed7aa' },
  { value: 3, label: 'متوسط', color: '#ca8a04', bg: '#fefce8', ring: '#fde68a' },
  { value: 4, label: 'خوب', color: '#16a34a', bg: '#f0fdf4', ring: '#bbf7d0' },
  { value: 5, label: 'عالی', color: '#233afa', bg: '#eef2ff', ring: '#c7d2fe' },
];

function FaceSvg({ value, size = 44 }) {
  const common = { width: size, height: size, viewBox: '0 0 64 64', 'aria-hidden': 'true' };
  if (value === 1) {
    return (
      <svg {...common}>
        <circle cx="32" cy="32" r="30" fill="#fecaca" />
        <circle cx="32" cy="32" r="26" fill="#ef4444" />
        <path d="M20 24l8 5M44 24l-8 5" stroke="#7f1d1d" strokeWidth="3.2" strokeLinecap="round" />
        <circle cx="22" cy="30" r="3.2" fill="#7f1d1d" />
        <circle cx="42" cy="30" r="3.2" fill="#7f1d1d" />
        <path d="M22 46c4-7 16-7 20 0" fill="none" stroke="#7f1d1d" strokeWidth="3.2" strokeLinecap="round" />
      </svg>
    );
  }
  if (value === 2) {
    return (
      <svg {...common}>
        <circle cx="32" cy="32" r="30" fill="#fed7aa" />
        <circle cx="32" cy="32" r="26" fill="#f97316" />
        <circle cx="22" cy="28" r="3.2" fill="#7c2d12" />
        <circle cx="42" cy="28" r="3.2" fill="#7c2d12" />
        <path d="M22 44c5-5 15-5 20 0" fill="none" stroke="#7c2d12" strokeWidth="3.2" strokeLinecap="round" />
        <path d="M46 38c2 3 2 7-1 9" fill="none" stroke="#fdba74" strokeWidth="2.4" strokeLinecap="round" />
      </svg>
    );
  }
  if (value === 3) {
    return (
      <svg {...common}>
        <circle cx="32" cy="32" r="30" fill="#fde68a" />
        <circle cx="32" cy="32" r="26" fill="#eab308" />
        <circle cx="22" cy="28" r="3.2" fill="#713f12" />
        <circle cx="42" cy="28" r="3.2" fill="#713f12" />
        <path d="M22 42h20" stroke="#713f12" strokeWidth="3.2" strokeLinecap="round" />
      </svg>
    );
  }
  if (value === 4) {
    return (
      <svg {...common}>
        <circle cx="32" cy="32" r="30" fill="#bbf7d0" />
        <circle cx="32" cy="32" r="26" fill="#22c55e" />
        <circle cx="22" cy="28" r="3.2" fill="#14532d" />
        <circle cx="42" cy="28" r="3.2" fill="#14532d" />
        <path d="M20 38c4 8 20 8 24 0" fill="none" stroke="#14532d" strokeWidth="3.2" strokeLinecap="round" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <circle cx="32" cy="32" r="30" fill="#c7d2fe" />
      <circle cx="32" cy="32" r="26" fill="#233afa" />
      <path d="M18 27c2-4 6-4 7 0M39 27c2-4 6-4 7 0" fill="none" stroke="#eef2ff" strokeWidth="3" strokeLinecap="round" />
      <path d="M18 38c5 10 23 10 28 0" fill="none" stroke="#eef2ff" strokeWidth="3.2" strokeLinecap="round" />
      <path d="M49 16l1.6 3.4L54 21l-3.4 1.6L49 26l-1.6-3.4L44 21l3.4-1.6z" fill="#fbbf24" />
    </svg>
  );
}

export function FeedbackHeroLogo({ size = 72 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 72 72" aria-hidden="true">
      <rect x="4" y="4" width="64" height="64" rx="20" fill="#233afa" />
      <path d="M20 28c0-6 5-11 16-11s16 5 16 11-5 11-16 11c-2 0-4-.2-6-.6L22 43l1.6-5.2C20.6 35.6 20 32 20 28z" fill="#fff" />
      <circle cx="30" cy="28" r="2.2" fill="#233afa" />
      <circle cx="36" cy="28" r="2.2" fill="#233afa" />
      <circle cx="42" cy="28" r="2.2" fill="#233afa" />
      <path d="M50 48l2 4.2L56.4 54 52 55.8 50 60 48 55.8 43.6 54 48 52.2z" fill="#fbbf24" />
    </svg>
  );
}

export function FeedbackSuccessLogo({ size = 88 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 88 88" aria-hidden="true">
      <circle cx="44" cy="44" r="40" fill="#dcfce7" />
      <circle cx="44" cy="44" r="32" fill="#22c55e" />
      <path d="M30 45l9 9 19-20" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function StarMark({ filled, size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 3.2l2.6 5.4 6 .9-4.3 4.2 1 5.9L12 16.8 6.7 19.6l1-5.9L3.4 9.5l6-.9z"
        fill={filled ? '#f59e0b' : '#e2e8f0'}
        stroke={filled ? '#d97706' : '#cbd5e1'}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RatingStars({ value = 0, size = 16 }) {
  const n = Number(value) || 0;
  return (
    <span style={{ display: 'inline-flex', gap: 2, alignItems: 'center' }} aria-label={`${n} از 5`}>
      {[1, 2, 3, 4, 5].map((i) => <StarMark key={i} filled={i <= n} size={size} />)}
    </span>
  );
}

export function ThumbUpIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M7 11v10H4a1 1 0 01-1-1v-8a1 1 0 011-1h3zm0 0l4.2-7.2A2.3 2.3 0 0115.3 5v4.2H20a2 2 0 011.9 2.5l-1.4 7A2 2 0 0118.6 21H7" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
  );
}

export function ThumbDownIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M7 13V3H4a1 1 0 00-1 1v8a1 1 0 001 1h3zm0 0l4.2 7.2A2.3 2.3 0 0015.3 19v-4.2H20a2 2 0 001.9-2.5l-1.4-7A2 2 0 0018.6 3H7" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
  );
}

export default function FeedbackMoodPicker({ value, onChange }) {
  return (
    <div className="pj-mood-grid" role="radiogroup" aria-label="امتیاز تجربه">
      {MOODS.map((mood) => {
        const selected = value === mood.value;
        return (
          <button
            key={mood.value}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={mood.label}
            className={`pj-mood-btn${selected ? ' is-selected' : ''}`}
            style={{
              '--mood-color': mood.color,
              '--mood-bg': mood.bg,
              '--mood-ring': mood.ring,
            }}
            onClick={() => onChange(mood.value)}
          >
            <FaceSvg value={mood.value} size={48} />
            <span className="pj-mood-label">{mood.label}</span>
          </button>
        );
      })}
    </div>
  );
}
